import React from 'react';

import PropTypes from 'prop-types';
import DisclaimerTooltip from './DisclaimerTooltip';
import FormField from './FormField';
import FormInput from './FormInput';
import {email} from 'helpers/email-validation';
import FormUtils from './../formUtils'

const styles = {
  'modal__title': 'email-signup-modal__title',
  'form': 'email-signup-form',
  'form-error': 'email-signup-form-error horizontalShake',
  'form-error-message': 'email-signup-form-error-message',
};

class FormPage extends React.Component {
  constructor() {
    super();
    this.state = {
      title: '',
      firstName: '',
      lastName: '',
      emailAddress: '',
      submitting: false,
      formErrors: {}
    };

    this.submitFormFields = this.submitFormFields.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
  }

  getFormErrors(state) {
    const { firstName, lastName, emailAddress } = state;

    return {
      firstName: !firstName || !FormUtils.isValidName(firstName),
      lastName: !lastName || !FormUtils.isValidName(lastName),
      emailAddress: !emailAddress || !email.validate.test(emailAddress)
    };
  }

  onInputChange(e) {
    const name = e.target.name;
    let value;

    switch (name) {
    case 'title':
      value = FormUtils.exludeSymbolsTitle(e.target.value);
      break;
    case 'firstName':
    case 'lastName':
      value = FormUtils.excludeSymbolsNames(e.target.value);
      break;
    default:
      value = e.target.value;
    }

    this.setState({[name]: value});
    this.setState(state => ({
      formErrors: this.getFormErrors(state)
    }));

    this.props.handleOnChange();
  }

  submitFormFields(e) {
    e.preventDefault();

    const { onFormSubmit } = this.props;
    const formErrors = this.getFormErrors(this.state);

    if (formErrors.firstName || formErrors.lastName || formErrors.emailAddress) {
      this.setState({ submitted: true, error: true, formErrors });
      this.props.onSubmitFailed(400);
    } else {
      this.setState({ submitted: true, submitting: true, error: false });

      const { title, firstName, lastName, emailAddress } = e.target;
      onFormSubmit({
        title: title.value,
        firstName: firstName.value,
        lastName: lastName.value,
        emailAddress: emailAddress.value,
      }).catch(() => this.setState({submitting: false}));
    }
  }

  render() {
    return (
      <div>

        <DisclaimerTooltip />

        {(this.state.error || this.props.submitFormErrorCode) && (
          <div role="alert" tabIndex="0" className={styles['form-error']}>
            <div className={styles['form-error-message']}>
              <h2>{
                this.state.error || this.props.submitFormErrorCode === 400 ?
                  'There are errors below, please correct them and try again'
                  :
                  `We're sorry, but something's not working right now, please try again later.`
              }</h2>
            </div>
          </div>
        )}

        <form
          className={styles.form}
          noValidate
          onSubmit={this.submitFormFields}
        >

          <FormField type="small">
            <FormInput
              name="title"
              label="Title (optional)"
              maxLength="10"
              value={this.state.title}
              disabled={this.state.submitting}
              onInputChange={this.onInputChange}
            />
          </FormField>
          <FormField>
            <FormInput
              name="firstName"
              label="First name"
              maxLength="35"
              dataErrorMessage={this.state.firstName ? 'Please enter a valid first name' : 'Please enter a first name'}
              displayError={this.state.submitted && this.state.formErrors.firstName}
              value={this.state.firstName}
              required
              disabled={this.state.submitting}
              onInputChange={this.onInputChange}
            />
          </FormField>
          <FormField>
            <FormInput
              name="lastName"
              label="Last name"
              maxLength="30"
              displayError={this.state.submitted && this.state.formErrors.lastName}
              dataErrorMessage={this.state.lastName ? 'Please enter a valid last name' : 'Please enter a last name'}
              value={this.state.lastName}
              required
              disabled={this.state.submitting}
              onInputChange={this.onInputChange}
            />
          </FormField>
          <FormField>
            <FormInput
              name="emailAddress"
              label="Email"
              maxLength="40"
              value={this.state.emailAddress}
              displayError={this.state.submitted && this.state.formErrors.emailAddress}
              dataErrorMessage={this.state.emailAddress ? 'Please enter a valid email address' : 'Please enter an email address'}
              required
              disabled={this.state.submitting}
              onInputChange={this.onInputChange}
            />
          </FormField>

          <button className={ this.state.submitting ? 'button button-primary-submitting' : 'button'} disabled={this.state.submitting}>
            <div>
              <span>Sign up</span>
            </div>
          </button>
        </form>
      </div>
    );
  }
}

FormPage.propTypes = {
  onFormSubmit: PropTypes.func.isRequired,
  onSubmitFailed: PropTypes.func.isRequired
};

export default FormPage;
